import React from "react";

export default function TopBorder({ className, width, height }) {
  return (
    <svg
      className={`${className} tbk-block tbk-shrink-0`}
      xmlns="http://www.w3.org/2000/svg"
      width="346"
      height="8"
      viewBox="0 0 346 8"
      role="presentation"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346 0H0L11.445 1.80472C12.2694 1.93471 13.1027 2 13.9372 2H107.812C108.925 2 110.026 2.23236 111.044 2.68223L119.641 6.47977C121.858 7.72438 126.336 8 131 8H215.379C220.042 8 224.142 7.72438 226.359 6.47977L234.925 2.68548C235.945 2.2335 237.049 2 238.165 2H332.038C332.871 2 333.702 1.93498 334.525 1.80555L346 0Z"
        fill="#303740"
      />
    </svg>
  );
}
